import { render, staticRenderFns } from "./MateriaPrimaPorProveedor.vue?vue&type=template&id=386b908e&"
import script from "./MateriaPrimaPorProveedor.vue?vue&type=script&lang=js&"
export * from "./MateriaPrimaPorProveedor.vue?vue&type=script&lang=js&"
import style0 from "./MateriaPrimaPorProveedor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports